import React, {useEffect} from "react";
import {Card} from "antd";
import SearchForm from "./SearchForm";
import SoList from "./SoList";
import {useModelDispatchers} from "../../../models";

export default function () {
    const {
        getInvoiceTypeDict,
        getSaleOrderTypeDict,
        getSalePriceTypeDict,
        getSaleStatusDict,
        getCustomerDict,
        getCustomerTypeDict,
        getOrgDict,
        getWarehouseDict,
        getAreaDict,
        getShelveDict,
        getPositionDict,
        getWhOutStatusDict,
        getPayTypeDict,
        getSalePayStatusDict,
    } = useModelDispatchers("cmDict");

    useEffect(() => {
        getInvoiceTypeDict();
        getSaleOrderTypeDict();
        getSalePriceTypeDict();
        getSaleStatusDict();
        getCustomerDict();
        getCustomerTypeDict();
        getWhOutStatusDict();
        getPayTypeDict();
        getSalePayStatusDict();

        getOrgDict();
        getWarehouseDict();
        getAreaDict();
        getShelveDict();
        getPositionDict();
    }, []);
    return (
        <>
            <Card
                bordered={true}
                className="margin-top-8"
                style={{display: "flex"}}
            >
                <div
                    style={{
                        margin: "8px 20px"
                    }}
                >
                    <SearchForm/>
                </div>
            </Card>
            <Card
                bordered={true}
                className="margin-top-8"
            >
                <SoList/>
            </Card>
        </>
    )
}